export default __webpack_public_path__ + "static/media/i197jk.f94b1ef8.webp";